import React from "react";
import {HeroTextWrapper, Header, HeroWrapper, HeroText} from "../HeroText";
import {ColoredButton, ButtonText as BtnText} from "BaseComponents/Button";
import useBreakpoint from "Hooks/useBreakpoint";
import {Ingress} from "BaseComponents/Text";
import {getButtonColor} from "Helpers/ColorHelper";
import {getResponsiveImage} from "Helpers/ImageHelper";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import "@splidejs/react-splide/dist/css/splide-core.min.css";
import "@splidejs/react-splide/dist/css/splide.min.css";
import LazyBackgroundImage from "../../framework/lazy/LazyBackgroundImage";

export const Hero = ({
         Heading,
         UseFontMarydale,
         Preamble,
         ButtonText,
         ButtonColor = "",
         ShowButton,
         ButtonLink,
         ButtonTarget,
         ResponsiveImages,
         HeroCurvedTextArea,
     }) => {
    const {color, textColor} = getButtonColor(ButtonColor);
    const Images = getResponsiveImage(ResponsiveImages);
    
    const mobileView = useBreakpoint("mobile");
    const ipadView = useBreakpoint("ipadPro");
    const showDesktop =
        Images &&
        ((!HeroCurvedTextArea && !mobileView) ||
            (HeroCurvedTextArea && !ipadView && !mobileView));
    return (
        <HeroWrapper heroCurvedTextArea={HeroCurvedTextArea}>
            <Splide
                className={'hero__splide'}
                aria-label="Hero slider"
                options={{
                    type: "loop",
                    perPage: 1,
                    lazyLoad: true,
                    cover: true,
                    arrows: false,
                    pagination: true,
                    autoplay: true,
                    height: 433,
                    interval: 7000,
                    speed: 4000,
                    drag: Images?.length > 1 ? true : false,
                    breakpoints: {
                        768: {
                            height: 200,
                        },
                        1023: {
                            height: 286,
                        },
                    },
                }}
            >
                {Images?.map((imageItem, index) => (
                    <SplideSlide key={index}>
                        <LazyBackgroundImage
                            paddingBottom="0"
                            timeout={100}
                            source={imageItem}
                            useFocalPoint
                        />
                    </SplideSlide>
                ))}
            </Splide>
            {showDesktop ? (
                <HeroText
                    {...{
                        Heading,
                        UseFontMarydale,
                        ButtonLink,
                        ButtonTarget,
                        ShowButton,
                        ButtonText,
                        Preamble,
                        ButtonColor,
                        HeroCurvedTextArea,
                    }}
                />
            ) : (
                <HeroTextWrapper
                    bgColor={HeroCurvedTextArea ? "#fff" : "rgba(247, 247, 247)"}
                    column
                    align="flex-start"
                    heroCurvedTextArea={HeroCurvedTextArea}
                >
                    {Heading && (
                        <Header
                            className={`${UseFontMarydale ? "marydale" : ""}`}
                            lineHeight="56px"
                        >
                            {Heading}
                        </Header>
                    )}
                    {Preamble && (
                        <Ingress
                            margin="0.5rem 0"
                            marginSmall="0.5rem 0 0.5rem 0"
                            color="black"
                            maxWidth="500px"
                        >
                            {Preamble}
                        </Ingress>
                    )}
                    {ShowButton && (
                        <ColoredButton
                            href={ButtonLink}
                            inverted
                            bgColor={color}
                            minWidth="180px"
                            width="fit-content"
                            color={textColor}
                            margin="1.5rem 0 0 0"
                            smallmargin="1.5rem 0 0 0"
                            padding="0.1rem 1rem"
                            zIndex="1"
                            target={ButtonTarget}
                            aria-label={ButtonText}
                        >
                            <BtnText color={textColor} heading={Heading || ''}>{ButtonText}</BtnText>
                        </ColoredButton>
                    )}
                </HeroTextWrapper>
            )}
        </HeroWrapper>
    );
};
